class GeoService {

	isSupported() {
		return typeof(navigator.geolocation) !== 'undefined';
	}

	getCoordinates(callback) {
		if (this.isSupported()) {
			navigator.geolocation.getCurrentPosition(position => {
				//Success
				callback(position.coords.latitude, position.coords.longitude);
			}, err => {
				//Error
				console.error('Failed to get position ->', err);
			});
		}
	}

}

module.exports = new GeoService();


// WEBPACK FOOTER //
// ./resources/js/services/geo.js